var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usageDetailsCom ashComWrap"},[_c('div',{staticClass:"tableBox"},[_c('OriginalTable',{attrs:{"tableHead":_vm.tableHead,"tableList":_vm.tableList}})],1),_c('div',{staticClass:"calendarBox"},[_c('Calendar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }